import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { actionGetRelationshipList } from "../../../actions/DataActions";
import { AFILIADOS } from "../../../config/RoutesConstants";
import VerticalListFields from "../../../components/VerticalListFields/VerticalListFields";
import AddFamily from "../../../components/AddFamily/AddFamily";
import { MODE_CRU_SHOW } from "../../../actions/ActionConstants";
import { ROL_OPERADOR_RECAUDA } from "../../../common/Constants";

class FamilityTab extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentWillMount() {
		if (!this.props.modeCRU) {
			this.props.history.push(AFILIADOS);
		}
	}

	render() {
		const disabled =
			this.props.rol === ROL_OPERADOR_RECAUDA ||
			this.props.modeCRU === MODE_CRU_SHOW;
		return (
			<div className="center">
				<VerticalListFields
					titleText="Datos de los Familiares"
					titleClass="title-papercard-primary"
					paperClass="papercard top10 bottom20"
					contentClass="content-papercard-around"
				>
					<AddFamily
						nameFieldType="relationship.id"
						nameFieldArray="family"
						nameFieldDNI="familyPerson.documentNumber"
						nameFieldName="familyPerson.name"
						nameFieldSurname="familyPerson.surname"
						nameFieldBirthDate="familyPerson.birthdate"
						nameFieldGender="familyPerson.gender.id"
						relationshipsTypeList={this.props.relationshipsListArray}
						gendersList={this.props.gendersList}
						disabled={disabled}
					/>
				</VerticalListFields>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		afiliado: store.afiliado.afiliado,
		provinciasList: store.locations.provinciasList,
		gendersList: store.data.gendersList,
		modeCRU: store.afiliado.modeCRU,
		rol: store.app.rol
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionGetRelationshipList
		},
		dispatch
	);
}
export default connect(mapStateToProps, mapDispatchToProps)(FamilityTab);



// WEBPACK FOOTER //
// ./src/screens/Afiliado/Tabs/FamilityTab.js